import React from "react";
import { Box, Button } from "@mui/material";
import { ReactComponent as SelectIcon } from "../../assets/icons/select-icon.svg";
import { ReactComponent as ShareIcon } from "../../assets/icons/share.svg";

const baseButtonSx = {
  height: "46px",
  textTransform: "none",
  fontWeight: "bold",
  fontFamily: "Globotipo Text",
  px: "16px",
  fontSize: "16px",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    color: "#FFFFFF",
    backgroundColor: "#CCCCCC",
    opacity: 0.8,
    pointerEvents: "none",
  },
};

const blueButtonSx = {
  ...baseButtonSx,
  backgroundColor: "#53B2DD",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#53B2DD",
    boxShadow: "none",
  },
};

const normalButtonSx = {
  ...baseButtonSx,
  backgroundColor: "#FFFFFF",
  border: "1px solid #E2E4FF",
  color: "#58627D",
  "&:hover": {
    backgroundColor: "#FFFFFF",
    border: "1px solid #E2E4FF",
    boxShadow: "none",
  },
};

const SelectShareButton = ({
  isSelectionMode = false,
  selectedFiles = [],
  handleSelectOrShare,
  isInsideUploadBox = false,
  hasFiles = false,
}) => {
  const buttonText = isSelectionMode
    ? "Compartilhar Arquivos"
    : "Selecionar Arquivos";

  const isDisabled =
    (isSelectionMode && selectedFiles.length === 0) ||
    (!isSelectionMode && !hasFiles);

  const wrapperSx =
    !isSelectionMode && isInsideUploadBox
      ? {
          display: "inline-flex",
          border: "1px solid #E2E4FF",
          borderRadius: "4px",
        }
      : { display: "inline-flex" };

  return (
    <Box sx={wrapperSx}>
      <Button
        variant="contained"
        disableElevation
        onClick={handleSelectOrShare}
        disabled={isDisabled}
        startIcon={isSelectionMode ? <ShareIcon /> : <SelectIcon />}
        data-qa="button-select-or-share"
        sx={isSelectionMode ? blueButtonSx : normalButtonSx}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default SelectShareButton;
